import React from 'react'

export type SectionLayoutProps = {
  children: any
  className: string
}
export default function SectionLayout({
  children,
  className
}: SectionLayoutProps) {
  const sectionClassName = className.startsWith('frw-')
    ? className
    : `frw-${className}`

  return (
    <>
      <section className={sectionClassName} data-aos-delay="50">
        <div className="frw-section frw-section--spacing-above frw-section--spacing-below">
          <div className="frw-wrapper--1">{children}</div>
        </div>
      </section>
    </>
  )
}
